import React from 'react';

const SpaceMathster = () => {
  return (
    <div className="container mt-4">
      <h2 className="text-center mb-4">Space Mathster</h2>
      <div className="card">
        <div className="card-body">
          <h5 className="card-title">Space Mathster</h5>
          <p className="card-text">
            Space Mathster is a fun space-themed math game recommended for children looking to improve and master their multiplication skills.
            An evil entity is attacking the planets in our solar system! Your mission is to fight back and defend our beautiful galactic backyard. Beat the timer to annihilate the dark power behind the evil entity and become a hero!
            The battle starts easy, with Mercury, our first planet in the solar system. Challenge yourself to clear all stages up to Pluto (yes – we believe Pluto deserves to be a planet!). Challenge yourself to rescue all nine planets and expel the evil entity from our solar system.
            <br />
            <br />
            <strong>Features:</strong>
            <ul>
              <li>It includes basic drills to practice multiplication tables from 1 to 9.</li>
              <li>Each level or “world” includes 3 stages with different types of exercises.</li>
              <li>You will have 30 seconds to select the right answers and clear the stage.</li>
              <li>All levels are unlocked in case you only need to practice one specific table.</li>
              <li>More updates, including an epic final boss battle is coming soon!</li>
            </ul>
          </p>
          <p className="card-text"><small className="text-muted">Privacy Policy</small></p>
          
        </div>
      </div>
    </div>
  );
};

export default SpaceMathster;
